import React from 'react';
import { createRoot } from 'react-dom/client';
import CheckoutPaymentDisplay from './components/payment/CheckoutPaymentDisplay';

const initializeCheckout = () => {
    const checkoutContainer = document.getElementById('wallet-up-checkout-container');
    
    if (checkoutContainer) {
        const root = createRoot(checkoutContainer);
        root.render(
            <React.StrictMode>
                <CheckoutPaymentDisplay />
            </React.StrictMode>
        );
    } else {
        console.error("❌ wallet-up-checkout-container not found in checkout page.");
    }
};

const initialize = () => {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeCheckout);
    } else {
        initializeCheckout();
    }

    if (window.jQuery) {
        window.jQuery(document.body).on('updated_checkout', () => {
            if (window.removeWalletUpCheckout) {
                window.removeWalletUpCheckout();
            }
            initializeCheckout();
        });
    }
};

window.removeWalletUpCheckout = () => {
    const container = document.getElementById('wallet-up-checkout-container');
    if (container) {
        const root = createRoot(container);
        root.unmount();
    }
};

initialize();